<template>
  <sa-page-layout :showModalLoading="showModalLoading" :pathResource="pathResource">
    <template slot="toolbar">
      <b-button class="float-sm-right" variant="success btn-toolbar sa-margin-right" size="sm"
        @click="onAggiungiModificaAccettazione"><b-icon icon="plus"></b-icon>Nuova Accettazione</b-button>
    </template>
    <template slot="table-filter">
      <b-form style="width: 100%" @submit.prevent="submit">
        <div class="sa-form-section sa-search-box">
          <b-row style="margin-left: 0.5rem; margin-right: 0.5rem" class="sa-form-btn-filter">
            <b-col cols="12" xs="12" sm="12" md="3" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Presidio</label>
                <div class="sa-page-search-component-wrapper">
                  <b-form-select class="sa-search-input mb-2 mr-sm-2 mb-sm-0" v-model="filtro.idPresidio" :value="null"
                    value-field="codiceStruttura" text-field="denominazione">
                    <template #first>
                      <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                    </template>
                    <template>
                      <b-form-select-option v-for="presidio of presidiOptions" :key="presidio.id"
                        :value="presidio.idPresidio">
                        {{ presidio.denominazionePresidio }} ({{ presidio.denominazioneStruttura
                        }})</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Codice Fiscale Assistito</label>
                <div class="sa-page-search-component-wrapper">
                  <input class="sa-search-box-input text-upper" v-model="filtro.codiceFiscaleAssistito" type="search"
                    id="ragioneSoggetto" placeholder="Ragione Sociale" />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Cognome Assistito</label>
                <div class="sa-page-search-component-wrapper">
                  <input class="sa-search-box-input text-upper" v-model="filtro.cognome" type="search"
                    id="cognomeassistito" placeholder="Cognome" />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Nome Assistito</label>
                <div class="sa-page-search-component-wrapper">
                  <input class="sa-search-box-input text-upper" v-model="filtro.nome" type="search" id="nomeassistito"
                    placeholder="Nome" />
                </div>
              </div>
            </b-col>

            <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Ricetta NRE</label>
                <div class="sa-page-search-component-wrapper">
                  <input class="sa-search-box-input text-upper mr-1" v-model="filtro.codiceBar1" type="search" id="bar1"
                    placeholder="NRE" />
                  <input class="sa-search-box-input text-upper" v-model="filtro.codiceBar2" type="search" id="bar2"
                    placeholder="NRE" />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Tipologia Ricetta</label>
                <div class="sa-page-search-component-wrapper">
                  <b-form-select class="sa-search-input mb-2 mr-sm-2 mb-sm-0 text-upper"
                    v-model="filtro.tipologiaRicetta" :value="null" :options="tipologiaRicettaOptions">
                    <template #first>
                      <b-form-select-option :value="null">- Tutte -</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Priorita</label>
                <div class="sa-page-search-component-wrapper">
                  <b-form-select class="sa-search-input mb-2 mr-sm-2 mb-sm-0 text-upper" v-model="filtro.priorita"
                    :value="null" :options="prioritaOptions">
                    <template #first>
                      <b-form-select-option :value="null">- Tutte -</b-form-select-option>
                    </template>
                  </b-form-select>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Accettazione Dal</label>
                <div class="sa-page-search-component-wrapper">
                  <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="filtro.dataOraInizio"
                    type="date"></date-picker>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Data Accettazione Al</label>
                <div class="sa-page-search-component-wrapper">
                  <date-picker format="DD/MM/YYYY" value-type="timestamp" v-model="filtro.dataOraFine"
                    type="date"></date-picker>
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
              <div class="sa-page-search-component-input-group" style="flex: 1; min-width: 70px">
                <label class="sa-search-box-label">Codice Fiscale Medico Prescrittore</label>
                <div class="sa-page-search-component-wrapper">
                  <input class="sa-search-box-input text-upper" v-model="filtro.cfMedico" type="search" id="cfmedico"
                    placeholder="" />
                </div>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12"
              style="padding: 8px; gap:10px; display: flex; justify-content: end;">
              <b-button type="submit" v-on:click="submit" variant="info">{{ this.$i18n.t("patients.lblFind")
              }}</b-button>
              <b-button type="reset" v-on:click="onReset" variant="danger">{{ this.$i18n.t("patients.lblResetFilter")
              }}</b-button>
            </b-col>

          </b-row>

        </div>
      </b-form>
    </template>
    <template slot="table-body">
      <accettazione-ssn-list-component ref="cmpAccettazioneSsnList" @openDetail="onOpenDetailRow"
        @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
      <b-modal ref="mdlAccettazioneSsn" :title="title" size="xl" style="height: 80%; max-height: 80%" centered
        scrollable>
        <accettazione-ssn-ricetta-edit-modal-component ref="cmpAccettazioneSsnModalComponent"
          @beforeLoadData="onBeforeLoadData" @afterLoadData="onAfterLoadData" />
        <template #modal-footer>
          <b-button size="sm" v-b-tooltip.hover title="Conferma" variant="success btn-toolbar sa-margin-right"
            @click="onConferma()">
            <font-awesome-icon icon="check" />
            Conferma
          </b-button>
        </template>
      </b-modal>
    </template>
  </sa-page-layout>
</template>

<script>
import axios from "axios";
import SaPageLayout from "../../../../template/sa/components/layout/contents/SaPageLayout.vue";
import UtilityMixin from "../../../utility/UtilityMixin";
import AccettazioneSsnListComponent from "../components/AccettazioneSsnListaComponentOlda.vue";
import AccettazioneSsnRicettaEditModalComponent from "../components/AccettazioneSsnRicettaViewModalComponent.vue";
import DatePicker from "vue2-datepicker";
//import { jsontest } from "../components/jsontest.js";

export default {
  components: {
    DatePicker,
    SaPageLayout,
    AccettazioneSsnListComponent,
    AccettazioneSsnRicettaEditModalComponent,
  },
  mixins: { UtilityMixin },
  data() {
    return {
      pathResource: "/accettazionessn",
      pathResourcePresidi: "/utentipresidi",
      resultSearchNreCf: [],
      rows: 0,
      perPage: 20,
      user: {},
      isRicercaComponent: false,
      presidiOptions: [],
      page: 1,
      presidio: null,
      prioritaOptions: ["U", "B", "D", "P"],
      filtro: {
        codiceFiscaleAssistito: null,
        tipologiaRicetta: null,
        codiceBar1: null,
        codiceBar2: null,
        dataOraInizio: null,
        idPresidio: null,
        dataOraFine: null,
        priorita: null,
        cfMedico: null,
      },
      listKey: 0,
      showModalLoading: false,
      title: "Accettazione SSN",
      tipologiaRicettaOptions: [
        { text: "CONV", value: "CONVEZIONATO" },
        { text: "SSN", value: "SSN" },
        { text: "ROSSA", value: "ROSSA" },
        { text: "PRIVATA", value: "PRIVATA" },
        { text: "DEMATERIALIZZATA", value: "DEMATERIALIZZATA" },
      ],
    };
  },
  mounted() {
    let me = this;

    this.getPresidio();
    if (this.presidio != null) {
      this.filtro.idPresidio = this.presidio.idPresidio;
    }
    me.loadUserData();
  },

  methods: {
    onOpenDetailRow() {
      let me = this;
      me.$refs.mdlAccettazioneSsn.show();
    },
    getPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        this.presidio = JSON.parse(tmpPresidio);
      }
    },
    loadUserData() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + "/users/profile";
      axios
        .get(link)
        .then((response) => {
          me.utente = response.data.data;
          me.user = me.utente;
          me.user.nominativoUtente = me.utente.lastname + " " + me.utente.firstname;
          me.user.ruolo = me.utente.profilo;
          me.loadDataUtentiPresidio(me.utente.id);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    onBeforeLoadData() {
      let me = this;
      me.showModalLoading = true;
    },
    onAfterLoadData() {
      let me = this;
      me.showModalLoading = false;
    },
    loadDataUtentiPresidio(id) {
      let me = this;
      UtilityMixin.methods.loadDataResources(me.pathResourcePresidi, { idUtente: id }, me.loadDataUtentiPresidiSuccess, me.loadDataUtentiPresidiError);
    },
    loadDataUtentiPresidiSuccess(response) {
      let me = this;
      me.presidiOptions = response.data.data.list;
      if (me.presidiOptions.length == 1) {
        me.filtro.idPresidio = me.presidiOptions[0].idPresidio;
      }
    },
    loadDataUtentiPresidiError(error) {
      console.log(error);
    },

    loadData() {
      let me = this;
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    submit() {
      let me = this;
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    onReset() {
      let me = this;
      me.filtro = {
        codiceFiscaleAssistito: null,
        tipologiaRicetta: null,
        codiceBar1: null,
        codiceBar2: null,
        dataOraInizio: null,
        dataOraFine: null,
        idPresidio: null,
        priorita: null,
        cfMedico: null,
        page: 1,
        forPage: me.forPage,
      };
      me.setFiltroSessionStorage(me.filtro);
      me.$refs.cmpAccettazioneSsnList.init();
    },
    onAggiungiModificaAccettazione(id) {
      let me = this;
      if (id) {
        id = "-1";
      }
      me.$router.push("accettazionessn/" + id);
    },
    setFiltroSessionStorage(filtro) {
      let me = this;
      me.filtro.page = me.page;
      me.filtro.forPage = me.perPage;
      sessionStorage.setItem("filtroPageAccettazioneSsn", JSON.stringify(filtro));
    },
    onConferma() {
      let me = this;
      console.log("Confermato chiamata REST....");
      console.log(me.jsonData);
    },
  },
};
</script>

<style scoped></style>
